import { authRequest } from '@/api/core';

export const verifyToken = (resultId, token, tokenType) => {
  return authRequest('token/verify', {
    method: 'POST',
    data: {
      token,
      tokenType,
      result_id: resultId
    }
  });
};
